// orderHist page strings (views/OrderHistV2View.vue). Keys are read as $t('orderHist.<key>').
// Field codes (SA/TR/TO/KH, FPS/FPK, ycdb/ycdb2), pack aliases and server data stay as-is.
export default {
  en: {
    search: {
      placeholder: 'Customer phone…',
      clear: 'Clear',
      newCustomer: 'New customer',
    },
    bar: {
      week: 'Week {week}',
      settings: 'View settings',
      thisWeek: 'This week',
      thisWeekTitle: 'Jump to the current week',
      latest: 'Latest order',
      latestTitle: "Jump to the customer's most recent package",
      last3: 'Last 3 months only',
      last3Hint: 'Faster load; untick for the full history.',
      last3Title: 'Only load the last 3 months of order history so a customer opens faster. Untick to load the whole history.',
      autoClean: 'Auto-clean address',
      autoCleanHint: 'Fill new ward and district from the typed address.',
      autoCleanTitle: 'Detect the district and new ward from the address when creating a customer or adding an address.',
      notesFollow: 'Notes follow the week',
      notesFollowHint: 'Filter notes by the selected week.',
      notesFollowTitle: 'Automatically filter the note list by week.',
    },
    legend: {
      thisWeek: 'this week',
      upcoming: 'upcoming',
      holiday: 'holiday',
      meals: 'meals',
    },
    profile: {
      copy: 'Copy name / address / phone',
      notFound: 'Not found',
      noCustomer: 'No customer',
      notFoundHint: 'No customer has this phone.',
      searchHint: 'Search a phone above.',
      showDietTraits: 'Show Diet & Traits',
      hideDietTraits: 'Hide Diet & Traits to give Notes more room',
      address: 'Address',
      addresses: 'Addresses',
      otherAddressOne: '{count} other address',
      otherAddressMany: '{count} other addresses',
      diet: 'Diet',
      traits: 'Traits',
      dietTraitsSummary: 'Diet ({diet}) · Traits ({traits}) — show',
    },
    notes: {
      title: 'Notes',
      types: {
        order: 'Order',
        payment: 'Payment',
        FFShip: 'FPS',
        FFKhac: 'FPK',
        ship: 'Ship',
        cancel: 'Cancel',
        other: 'Other',
      },
      channels: {
        phone: 'Phone',
        facebook: 'Facebook',
        other: 'Other',
      },
      placeholder: 'Note description  (Ctrl+Enter to create)',
      pickWeek: 'Pick a week for the note',
      tooOld: 'Week {week} — notes only within 5 weeks',
      targetPack: 'Week {week} · {pack} #{id}',
      week: 'Week {week}',
      create: 'Create',
      search: 'Search notes',
      empty: 'No notes.',
      status: {
        done: 'done',
        pending: 'pending',
      },
    },
    board: {
      weeksGap: 'wk',
      week: 'week',
      thisWeek: 'this week',
      holiday: 'holiday',
      upcoming: 'upcoming',
      meals: '{count} meals',
      days: {
        mon: 'mon',
        tue: 'tue',
        wed: 'wed',
        thu: 'thu',
        fri: 'fri',
      },
    },
    tabs: {
      orderList: 'Orders',
      info: 'Info',
      details: 'Details',
      customerBalance: 'Balance',
    },
    orders: {
      title: "Customer's orders",
      clear: 'Clear',
      bill: 'Detailed bill',
      search: 'Search orders',
      cols: {
        week: 'Week',
        id: 'ID',
        pack: 'Pack',
        shipLoc: 'Ship loc',
        total: 'Total',
        mealNote: 'Meal note',
      },
      empty: 'No orders.',
    },
    info: {
      packInfo: 'Package info',
      pack: 'Pack',
      mealRequests: 'Meal requests',
      mealNote: 'Meal note',
      shipRequests: 'Delivery requests',
      shipLoc: 'Ship loc',
      address: 'Address',
      weeklyNote: 'Weekly note (2)',
      fixedNote: 'Fixed note (1)',
      receipt: 'Price breakdown',
      customer: 'Customer:',
      weekParen: '(week {week})',
      subtotal: 'Subtotal',
      discount: 'Discount',
      total: 'Total due',
      empty: 'Select a package on the board or in the order list.',
    },
    invoice: {
      pack: '{pack} ({meals} meals)',
      ship: 'Ship {loc} ({days} days)',
      shipOtherPack: ' (for ID: {id})',
      shipAdj: 'Shipping price adjustment',
      side: '{name} ({qty} x)',
      sideAdj: 'Side product price adjustment',
      special: 'ycdb service fee',
      other: 'Other',
    },
    details: {
      title: 'Package details for week',
      idParen: '(id: {id})',
      rows: {
        shipDis: 'ship loc',
        deliverTimeslot: 'time',
        shipper: 'shipper',
        address: 'address',
      },
      empty: 'No packages with meals in this week.',
    },
    balance: {
      title: 'Customer balance over the last 12 months',
      search: 'Search transactions',
      cols: {
        no: 'No.',
        date: 'Date',
        week: 'Week',
        food: 'Food',
        paid: 'Paid',
        due: 'Owed (credit)',
        description: 'Description',
      },
      empty: 'No transactions.',
    },
    addresses: {
      title: 'Addresses',
      active: 'Active',
      all: 'All',
      newAddress: 'New address',
      main: 'Main address',
      inactive: 'inactive',
      newWard: 'new ward',
      district: 'district',
      ward: 'ward',
      makeMain: 'Make main',
      deactivate: 'Deactivate',
      activate: 'Activate',
      empty: 'No other addresses.',
    },
    form: {
      newCustomer: 'New customer',
      newAddress: 'New address',
      phone: 'Customer phone',
      phonePlaceholder: '10 digits',
      email: 'Email',
      emailPlaceholder: 'email',
      name: 'Customer name',
      namePlaceholder: 'Customer name',
      address: 'Address',
      addressPlaceholder: 'Customer address',
      newWard: 'New ward',
      newWardPlaceholder: 'Type to search new ward…',
      district: 'District',
      districtPlaceholder: 'Type to search district…',
      ward: 'Ward',
      wardHint: '(from auto-clean)',
      cancel: 'Cancel',
      createCustomer: 'Create customer',
      createAddress: 'Create address',
      close: 'Close',
    },
    errors: {
      addressTooShort: 'The customer Address must have at least 10 characters',
      addressExists: 'This address already exists for this customer',
      pickCustomer: 'Please select a customer first',
      pickNewWard: 'Please select a New Ward',
      pickDistrict: 'Please select a District',
      nameMissing: 'The customer Name is missing',
      phoneMissing: 'The customer Phone is missing',
      addressMissing: 'The customer Address is missing',
      emailMissing: 'The customer Email is missing',
      phoneDigits: 'The customer Phone must have 10 digits',
      emailInvalid: 'The customer Email is not valid',
    },
  },
  vi: {
    search: {
      placeholder: 'Số điện thoại khách…',
      clear: 'Xoá',
      newCustomer: 'Khách hàng mới',
    },
    bar: {
      week: 'Tuần {week}',
      settings: 'Tuỳ chọn hiển thị',
      thisWeek: 'Tuần này',
      thisWeekTitle: 'Chọn tuần hiện tại',
      latest: 'Đơn mới nhất',
      latestTitle: 'Đến gói ăn gần nhất của khách',
      last3: 'Chỉ 3 tháng gần nhất',
      last3Hint: 'Mở nhanh hơn; bỏ chọn để xem toàn bộ lịch sử.',
      last3Title: 'Chỉ tải lịch sử đơn hàng trong 3 tháng gần nhất để mở khách hàng nhanh hơn. Bỏ chọn để tải toàn bộ lịch sử.',
      autoClean: 'Tự làm sạch địa chỉ',
      autoCleanHint: 'Tự điền phường mới và quận từ địa chỉ đã nhập.',
      autoCleanTitle: 'Tự động nhận diện Quận và Phường mới từ địa chỉ khi tạo khách hàng hoặc thêm địa chỉ.',
      notesFollow: 'Ghi chú theo tuần',
      notesFollowHint: 'Lọc ghi chú theo tuần đang chọn.',
      notesFollowTitle: 'Tự động lọc danh sách Note theo tuần.',
    },
    legend: {
      thisWeek: 'tuần này',
      upcoming: 'sắp tới',
      holiday: 'ngày nghỉ',
      meals: 'phần ăn',
    },
    profile: {
      copy: 'Sao chép tên / địa chỉ / SĐT',
      notFound: 'Không tồn tại',
      noCustomer: 'Chưa chọn khách',
      notFoundHint: 'Không có khách hàng với SĐT này.',
      searchHint: 'Tìm SĐT ở ô phía trên.',
      showDietTraits: 'Hiện Diet & Traits',
      hideDietTraits: 'Ẩn Diet & Traits để mở rộng phần Notes',
      address: 'Địa chỉ',
      addresses: 'Địa chỉ',
      otherAddressOne: '{count} địa chỉ khác',
      otherAddressMany: '{count} địa chỉ khác',
      diet: 'Diet',
      traits: 'Traits',
      dietTraitsSummary: 'Diet ({diet}) · Traits ({traits}) — hiện',
    },
    notes: {
      title: 'Ghi chú',
      // note types stay in English in both languages
      types: {
        order: 'Order',
        payment: 'Payment',
        FFShip: 'FPS',
        FFKhac: 'FPK',
        ship: 'Ship',
        cancel: 'Cancel',
        other: 'Other',
      },
      channels: {
        phone: 'Điện thoại',
        facebook: 'Facebook',
        other: 'Khác',
      },
      placeholder: 'Nội dung ghi chú  (Ctrl+Enter để tạo)',
      pickWeek: 'Chọn tuần cho ghi chú',
      tooOld: 'Tuần {week} — chỉ ghi chú trong 5 tuần',
      targetPack: 'Tuần {week} · {pack} #{id}',
      week: 'Tuần {week}',
      create: 'Tạo',
      search: 'Tìm ghi chú',
      empty: 'Chưa có ghi chú.',
      status: {
        done: 'xong',
        pending: 'đang chờ',
      },
    },
    board: {
      weeksGap: 'tuần',
      week: 'tuần',
      thisWeek: 'tuần này',
      holiday: 'ngày nghỉ',
      upcoming: 'sắp tới',
      meals: '{count} meals', // kept in English on the week board
      days: {
        mon: 'T2',
        tue: 'T3',
        wed: 'T4',
        thu: 'T5',
        fri: 'T6',
      },
    },
    tabs: { // kept in English in both languages
      orderList: 'Orders',
      info: 'Info',
      details: 'Details',
      customerBalance: 'Balance',
    },
    orders: {
      title: 'Danh sách order của khách',
      clear: 'Bỏ chọn',
      bill: 'Bill chi tiết',
      search: 'Tìm đơn hàng',
      cols: {
        week: 'Tuần',
        id: 'ID',
        pack: 'Gói',
        shipLoc: 'Khu ship',
        total: 'Tổng',
        mealNote: 'Ghi chú phần ăn',
      },
      empty: 'Chưa có đơn hàng.',
    },
    info: {
      packInfo: 'Thông tin gói ăn',
      pack: 'Gói',
      mealRequests: 'Yêu cầu món ăn',
      mealNote: 'Ghi chú phần ăn',
      shipRequests: 'Yêu cầu ship',
      shipLoc: 'Khu ship',
      address: 'Địa chỉ',
      weeklyNote: 'Note 2 hàng tuần',
      fixedNote: 'Note 1 cố định',
      receipt: 'Chi tiết thành tiền',
      customer: 'Khách hàng:',
      weekParen: '(tuần {week})',
      subtotal: 'Tổng giá',
      discount: 'Giảm giá',
      total: 'Thành tiền',
      empty: 'Chọn một gói ăn trên bảng tuần hoặc trong danh sách đơn.',
    },
    invoice: {
      pack: '{pack} ({meals} phần)',
      ship: 'Ship {loc} ({days} ngày)',
      shipOtherPack: ' (theo ID: {id})',
      shipAdj: 'Điều chỉnh giá ship',
      side: '{name} ({qty} x)',
      sideAdj: 'Điều chỉnh giá sản phẩm phụ',
      special: 'Phí dịch vụ ycdb',
      other: 'Khác',
    },
    details: {
      title: 'Thông tin chi tiết các package trong tuần',
      idParen: '(id: {id})',
      rows: {
        shipDis: 'khu ship',
        deliverTimeslot: 'giờ giao',
        shipper: 'shipper',
        address: 'địa chỉ',
      },
      empty: 'Tuần này không có gói ăn nào.',
    },
    balance: {
      title: 'Số dư khách hàng trong 1 năm qua',
      search: 'Tìm giao dịch',
      cols: {
        no: 'STT',
        date: 'Ngày',
        week: 'Tuần',
        food: 'Tiền ăn',
        paid: 'Tiền trả',
        due: 'Thiếu (dư)',
        description: 'Diễn giải',
      },
      empty: 'Chưa có giao dịch.',
    },
    addresses: {
      title: 'Địa chỉ',
      active: 'Đang dùng',
      all: 'Tất cả',
      newAddress: 'Thêm địa chỉ',
      main: 'Địa chỉ chính',
      inactive: 'ngưng dùng',
      newWard: 'phường mới',
      district: 'quận',
      ward: 'phường',
      makeMain: 'Đặt làm chính',
      deactivate: 'Ngưng dùng',
      activate: 'Dùng lại',
      empty: 'Không có địa chỉ khác.',
    },
    form: {
      newCustomer: 'Khách hàng mới',
      newAddress: 'Thêm địa chỉ',
      phone: 'SĐT khách hàng',
      phonePlaceholder: '10 chữ số',
      email: 'Email',
      emailPlaceholder: 'email',
      name: 'Tên khách hàng',
      namePlaceholder: 'Tên khách hàng',
      address: 'Địa chỉ',
      addressPlaceholder: 'Địa chỉ khách hàng',
      newWard: 'Phường mới',
      newWardPlaceholder: 'Gõ để tìm phường mới…',
      district: 'Quận',
      districtPlaceholder: 'Gõ để tìm quận…',
      ward: 'Phường',
      wardHint: '(tự nhận diện)',
      cancel: 'Huỷ',
      createCustomer: 'Tạo khách hàng',
      createAddress: 'Tạo địa chỉ',
      close: 'Đóng',
    },
    errors: {
      addressTooShort: 'Địa chỉ khách hàng phải có ít nhất 10 ký tự',
      addressExists: 'Địa chỉ này đã có cho khách hàng',
      pickCustomer: 'Vui lòng chọn khách hàng trước',
      pickNewWard: 'Vui lòng chọn Phường mới',
      pickDistrict: 'Vui lòng chọn Quận',
      nameMissing: 'Thiếu tên khách hàng',
      phoneMissing: 'Thiếu SĐT khách hàng',
      addressMissing: 'Thiếu địa chỉ khách hàng',
      emailMissing: 'Thiếu email khách hàng',
      phoneDigits: 'SĐT khách hàng phải có 10 chữ số',
      emailInvalid: 'Email khách hàng không hợp lệ',
    },
  },
}
